import React, { useEffect, useState } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { track } from '../lib/analytics';
import './Services.css';
import './ServiceDetail.css';

function formatPrice(p) {
  const n = Number(p);
  if (Number.isNaN(n)) return '';
  return `$${n.toFixed(2).replace(/\.00$/, '')}`;
}

export default function ServiceDetail() {
  const { slug } = useParams();
  const location = useLocation();
  const [service, setService] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setService(null);
    setError(false);
    fetch(`${API_BASE_URL}/api/services/${slug}`)
      .then((r) => {
        if (!r.ok) { if (!cancelled) setError(true); return null; }
        return r.json();
      })
      .then((data) => { if (data && !cancelled) setService(data); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [slug]);

  if (error) {
    return (
      <main className="service-detail-main">
        <div className="service-detail-notfound">
          <p>We couldn't find that service.</p>
          <Link to="/services">← Back to services</Link>
        </div>
      </main>
    );
  }

  if (!service) {
    return (
      <main className="service-detail-main">
        <div className="services-loading">Loading...</div>
      </main>
    );
  }

  const initial = (service.name || '?').charAt(0).toUpperCase();
  return (
    <main className="service-detail-main">
      <Link to="/services" className="service-detail-back">← Back to services</Link>
      {service.image ? (
        <img className="service-detail-hero" src={service.image} alt={service.name} />
      ) : (
        <div className="service-detail-hero service-detail-hero-fallback" aria-hidden="true">{initial}</div>
      )}
      <h1 className="service-detail-name">{service.name}</h1>
      {service.description && <p className="service-detail-desc">{service.description}</p>}
      {service.pricing?.length > 0 && (
        <table className="service-pricing">
          <tbody>
            {service.pricing.map((p) => (
              <tr key={p.id}>
                <td>{p.label || `${p.durationMinutes} min`}</td>
                <td className="price">{formatPrice(p.price)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {service.addons?.length > 0 && (
        <div className="service-addons">
          <div className="service-addons-label">Add-ons</div>
          <ul>
            {service.addons.map((a) => (
              <li key={a.id}>
                <span>{a.name}</span>
                <span className="addon-meta">
                  {Number(a.priceDelta) > 0 ? ` +${formatPrice(a.priceDelta)}` : ''}
                  {a.durationDelta > 0 ? ` · +${a.durationDelta} min` : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="service-detail-cta-row">
        <Link
          to="/book"
          className="service-detail-cta"
          onClick={() => track('BOOK_INTENT', location.pathname)}
        >
          Book This Service
        </Link>
        <Link to={`/contact?service=${service.slug}`} className="service-detail-cta service-detail-cta-outline">
          Inquire about this service
        </Link>
      </div>
    </main>
  );
}
